import { useContext, useMemo } from "react";
import { pluralize } from "@common/helpers/string";
import importerStyles from "@components/importer/ImporterPage.module.scss";
import { AccrualImporterContext } from "./accrualImporter.context";
import {
    accrualDocumentBeingProcessed,
    isAccrualRowReadyForImport,
} from "./accrualImporter.helpers";

export const AccrualImporterPageStatus: React.FC = () => {
    const { documentRows } = useContext(AccrualImporterContext);

    const processedDocuments = useMemo(
        () =>
            documentRows.filter(
                (row) =>
                    row.financialDocument &&
                    !accrualDocumentBeingProcessed(row.financialDocument),
            ),
        [documentRows],
    );

    const readyToImportCount = useMemo(
        () => processedDocuments.filter(isAccrualRowReadyForImport).length,
        [processedDocuments],
    );

    return (
        <div className={importerStyles.pageStatus}>
            {documentRows.length > 0 ? (
                <span className={importerStyles.pageStatusItem}>
                    Processed {processedDocuments.length} of{" "}
                    {documentRows.length}{" "}
                    {pluralize("document", documentRows.length)}
                </span>
            ) : (
                <span className={importerStyles.pageStatusItem}>
                    Processed 0 documents
                </span>
            )}
            <span className={importerStyles.pageStatusItem}>
                {readyToImportCount} ready to import
            </span>
        </div>
    );
};
